import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { type Skill } from "./entity";

export const SkillEntityConfig: HyperEntityConfig<Skill> = {
  allowApiCrud: false,
  allowApiRead: true,

  allowInsertPerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);
  },
};
